import React from 'react';
import { ShieldPlus, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="w-full border-t bg-gradient-to-br from-gray-50 to-blue-50 mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/kindred-footer-logo.jpg" 
                alt="Kindred Pharmaceuticals Logo" 
                className="h-32 w-auto object-contain mix-blend-multiply"
              />
            </div>
            <p className="text-sm text-gray-600 max-w-md mb-4">
              Your trusted partner in healthcare. Providing quality pharmaceutical products
              with commitment to excellence and patient safety.
            </p>
            <div className="flex flex-col space-y-2 text-sm text-gray-600">
              <div className="flex items-center space-x-2">
                <MapPin className="h-4 w-4 text-blue-600" />
                <span>R-1,2/4 Gorwa BIDC, Vadodara, Gujarat - 390016</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-blue-600" />
                <span>+91 7069010606</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-blue-600" />
                <span>kindredpharmaceuticals@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="/" className="hover:text-blue-600 transition-colors">Products</a></li>
              <li><a href="/about" className="hover:text-blue-600 transition-colors">About Us</a></li>
              <li><a href="/contact" className="hover:text-blue-600 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Information</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="#" className="hover:text-blue-600 transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-blue-600 transition-colors">Terms & Conditions</a></li>
              <li><a href="#" className="hover:text-blue-600 transition-colors">Safety Information</a></li>
              <li><a href="#" className="hover:text-blue-600 transition-colors">FDA Compliance</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 text-center text-sm text-gray-600">
          <p>&copy; 2024 Kindred Pharmaceuticals Pvt Ltd. All rights reserved.</p>
          <p className="mt-2 text-xs text-gray-500">
            Always consult a healthcare professional before starting any medication.
          </p>
        </div>
      </div>
    </footer>
  );
};
